// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7ec7eadb","239":"ec11dd2d","453":"33bf79fb","732":"c57c2f0f"}[chunkId] + ".chunk.js";
};